
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonModal,
  IonPage,
  IonRouterOutlet,
  IonSearchbar,
  IonTabs,
  IonTabBar,
  IonTabButton,
  IonTitle,
  IonToolbar
} from '@ionic/vue';
import { sync, layers, arrowBack, cube, person } from 'ionicons/icons';
import {useRoute, useRouter} from "vue-router";
import {defineComponent} from "vue";
import { Preferences } from '@capacitor/preferences';
import DeliveryDataService from "@/services/DeliveryDataService";
import NavigationHistoryService from "@/services/NavigationHistoryService";

export default defineComponent({
  name: 'UnauthenticatedTabs',
  data: () => {
    return {
      uuid: useRoute().params.id as string,
      searchModalVisible: false as boolean,
      searchResults: [] as any[]
    };
  },
  components: {  IonButton, IonButtons, IonContent, IonHeader, IonLabel, IonTabs, IonTabBar, IonTabButton, IonIcon, IonItem, IonModal, IonPage, IonRouterOutlet, IonSearchbar, IonTitle, IonToolbar },
  setup() {
    const router = useRouter();
    return {
      layers,
      sync,
      arrowBack,
      cube,
      person,
      router
    }
  },
  methods: {
    back() {
      try {
        // Check if we're currently on a delivery item page
        const currentRoute = this.$route.path;
        const itemMatch = currentRoute.match(/\/di\/([^/]+)/);

        if (itemMatch) {
          const itemUuid = itemMatch[1];

          // Check navigation history for this item
          const navigationHistory = NavigationHistoryService.getNavigation(itemUuid);

          if (navigationHistory) {
            if (navigationHistory.from === 'delivery') {
              // Navigate back to delivery view
              this.router.push(`/c/d/${navigationHistory.uuid}`);
              return;
            } else if (navigationHistory.from === 'kit') {
              // Navigate back to kit view
              this.router.push(`/c/dk/${navigationHistory.uuid}`);
              return;
            }
          }
        }

        // Fallback: try to get delivery UUID from preferences
        Preferences.get({ key: 'delivery_uuid' }).then((result) => {
          if(result.value != null){
            const deliveryUuid = JSON.parse(result.value);
            this.router.push(`/c/d/${deliveryUuid}`);
          } else {
            this.router.go(-1);
          }
        }).catch((error) => {
          console.error('Error getting delivery UUID for back navigation:', error);
          this.router.go(-1);
        });

      } catch (error) {
        console.error('Error in back navigation:', error);
        // Final fallback to browser back
        this.router.go(-1);
      }
    },
    goToDelivery(){
      // Get the delivery UUID from preferences (same as AuthenticatedTabs.vue)
      Preferences.get({ key: 'delivery_uuid' }).then((result) => {
        if(result.value != null){
          const deliveryUuid = JSON.parse(result.value);
          this.router.push(`/c/d/${deliveryUuid}`);
        }
      }).catch((error) => {
        console.error('UnauthenticatedTabs: Error getting delivery UUID from preferences:', error);
      });
    },
    goToDeliveryKit(id: string){
      this.dismissSearchResults();
      this.router.push(`/c/dk/${id}`);
    },
    goToDeliveryItem(id: string){
      this.dismissSearchResults();
      this.router.push(`/c/di/${id}`);
    },
    searchInputChange(searchStuff: any){
      if(searchStuff.detail.value != ""){
        Preferences.get({ key: 'delivery_uuid' }).then((result) => {
          if(result.value != null){
            const searchString = searchStuff.detail.value;
            const uuid = result.value.toString().replaceAll('"', '');
            DeliveryDataService.search( uuid,searchString,(error: any, results: any) => {
              if(error){
                console.error('UnauthenticatedTabs: search failed:', error);
              }
              if(results && results.length > 0){
                this.searchModalVisible = true;
                this.searchResults = results;
              } else {
                this.searchModalVisible = false;
                this.searchResults = [];
              }
            });
          }
        });
      } else {
        this.searchModalVisible = false;
        this.searchResults = [];
      }
    },
    dismissSearchResults(){
      this.searchModalVisible = false;
      this.searchResults = [];
    }
  }
});
